import { LoadingSkeleton, Select } from '@bloomfieldrobotics/canopy';
import { useVarietiesByCustomer } from '../../../../services/entities/hooks/useVarietiesByCustomer';
import { CropTypes } from '../../../../services/entities/impl/blfApi/schemas/variety';

type Props = {
  customerId: string;
  value: string;
  onChange: (value: string) => void;
};

const INTERNAL_ALL_VALUE = 'internal-all-value';

export const ClusterVarietySelect = ({
  customerId,
  value,
  onChange,
}: Props) => {
  const { varieties, isVarietiesLoading } = useVarietiesByCustomer(customerId, [
    CropTypes.WineGrapes,
    CropTypes.JuiceGrapes,
    CropTypes.TableGrapes,
  ]);

  const options = [
    {
      label: 'All',
      value: INTERNAL_ALL_VALUE,
    },
  ].concat(
    varieties?.map((variety) => ({
      label: variety.name,
      value: variety.id,
    })) || []
  );

  const handleChange = (value: string) => {
    const actualValue = value === INTERNAL_ALL_VALUE ? '' : value;
    onChange(actualValue);
  };

  // Check if current value exists in available options
  // If not (e.g., while loading or invalid ID), fall back to "All"
  const currentValueExists =
    value && options.some((option) => option.value === value);
  const displayValue = currentValueExists ? value : INTERNAL_ALL_VALUE;

  return (
    <LoadingSkeleton loading={isVarietiesLoading}>
      <Select
        variant='minimal'
        options={options}
        value={displayValue}
        onChange={handleChange}
      />
    </LoadingSkeleton>
  );
};
